export default {
    GET_SNACKBAR(state) {
        return state.snackbar;
    },
    GET_TITLE(state) {
        return state.title;
    },
}